import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';

function Q2Conclusion() {
  const {
    lightColor, darkColor,
  } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            What does the data say?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={10} sm={6}>
              <MessageBox>
                <Typography variant="h5" gutterBottom>Are children at risk of lead exposure at home?</Typography>
                <Typography variant="body1">
                  Many children are at risk for lead exposure at home, but some of those children are not receiving regular blood lead level tests. When child care providers encourage families to get their children tested for lead, elevated blood levels can be detected and the sources of lead exposure can be addressed.
                </Typography>
              </MessageBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Q2Conclusion;
